import React from "react";
import Particles from "react-tsparticles";

// Les collisions "bounce" de tsparticles conservent l'énergie avec une masse liée à la taille :
// une petite bulle qui percute une grosse repart plus vite. Ce plugin remet chaque bulle
// à sa vitesse de départ (en gardant sa nouvelle direction) juste avant qu'elle se déplace,
// pour qu'aucune n'accélère, même pendant une seule image.
const constantSpeedPlugin = {
  id: "constantSpeed",
  needsPlugin: () => true,
  loadOptions: () => {},
  getPlugin: () => ({
    particleUpdate(particle) {
      const base = Math.hypot(particle.initialVelocity.x, particle.initialVelocity.y);
      const speed = Math.hypot(particle.velocity.x, particle.velocity.y);
      if (!speed || !base) {
        return;
      }
      particle.velocity.x *= base / speed;
      particle.velocity.y *= base / speed;
    },
  }),
};

async function initParticles(engine) {
  await engine.addPlugin(constantSpeedPlugin);
}

function Particle() {
  return (
    <Particles
      id="tsparticles"
      className="page-particles"
      init={initParticles}
      params={{
        fullScreen: { enable: false },
        particles: {
          number: {
            value: 20, // Nombre par zone de la taille d'un écran
            density: {
              enable: true,
              value_area: 2000, // Augmente la zone pour espacer
            },
          },
          color: {
            value: ["#22d3ee", "#3b82f6", "#14b8a6", "#4ade80"],
          },
          shape: {
            type: "circle", // Forme des particules
          },
          size: {
            value: 120, // Taille moyenne
            random: true, // Taille variable
          },
          opacity: {
            value: 0.07,
          },
          move: {
            enable: true,
            speed: 1, // Mouvement très léger
            direction: "none", // Mouvement aléatoire
            random: true,
            straight: false,
            out_mode: "bounce", // Empêche les bulles de sortir de la page
          },
          collisions: {
            enable: true, // Les bulles rebondissent entre elles (vitesse bridée par constantSpeedUpdater)
            mode: "bounce",
          },
        },
        interactivity: {
            detect_on: "window", // Le canvas est derrière le contenu : on écoute la souris sur toute la fenêtre
            events: {
              onhover: {
                enable: true, // Active l'interaction au survol
                mode: "bubble", // Les particules grossissent au survol
              },
              resize: true, // Recalcule la taille du canvas quand la page s'allonge
            },
            modes: {
              bubble: {
                distance: 120, // Distance à laquelle l'effet de bulle se déclenche
                size: 130, // Taille des particules lorsqu'elles grossissent
                duration: 2, // Durée de l'effet
                opacity: 0.16, // Opacité des particules pendant l'effet
                speed: 5, // Vitesse de l'effet
              },
            },
          },
        // Le canvas fait toute la hauteur de la page : en haute densité de pixels il dépasserait
        // la taille maximale autorisée sur mobile (iOS notamment).
        retina_detect: false,
      }}
    />
  );
}

export default Particle;
